import {bufferGeoJSON} from "./buffer-geojson";
import {IFeature_CONO} from "../types";

export function bufferFeature (feature: IFeature_CONO, bufferAmount: number, units='degrees'): IFeature_CONO {
    // if (units === 'feet') {
    //     units = 'kilometers';
    // bufferAmount /= 3280.84;
    // bufferAmount *= 0.3048;
    // bufferAmount /= 1000;
    // bufferAmount *= 0.000189394;
    // bufferAmount /= 364567.2
    bufferAmount *= 0.000189394;
    // }
    // bufferAmount *= 1.13;
    // bufferAmount * 1000;

    return bufferGeoJSON(feature, bufferAmount, 'miles', 64) as any as IFeature_CONO;
}

